import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Activity } from '@wilson/interfaces';
import { ShiftTimelinePipesModule } from '@wilson/shift-timeline/pipes';

import {
  GanttEndingPixelPipe,
  GanttStartingPixelPipe,
  SelectedItemOutput,
  TimeDifferenceWidthPxPipe,
} from '@wilson/shift-timeline/assignments-gantt-chart';
import { ActivityCardComponent } from './activity-card/activity-card.component';

@Component({
  selector: 'wilson-activities-row',
  templateUrl: './activities-row.component.html',
  styleUrls: ['./activities-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ShiftTimelinePipesModule,
    TimeDifferenceWidthPxPipe,
    GanttStartingPixelPipe,
    GanttEndingPixelPipe,
    ActivityCardComponent,
  ],
})
export class ActivitiesRowComponent {
  @Input() activities!: Activity[];
  @Input() dottedBorder = false;
  @Input() isHovered = false;
  @Output() selected = new EventEmitter<SelectedItemOutput>();

  LEFT_RIGHT_ADJUSTMENT = 4;

  handleClick(
    event: Event,
    activityId: string,
    left: number | null,
    right: number | null,
  ) {
    event.preventDefault();
    event.stopPropagation();

    this.selected.emit({
      id: activityId,
      left,
      right,
    });
  }
}
